import React from 'react'

import * as SwitchPrimitive from '@radix-ui/react-switch';

import * as S from './styles';

export function Switch({ children, ...props }: SwitchPrimitive.SwitchProps & React.ComponentProps<typeof S.SwitchPrimitiveRoot>) {
  return (
    <S.SwitchPrimitiveRoot {...props} >
      {children}
    </S.SwitchPrimitiveRoot>
  );
}

export function SwitchThumb({ children, ...props }: SwitchPrimitive.SwitchThumbProps & React.ComponentProps<typeof S.SwitchPrimitiveThumb>) {
  return (
    <S.SwitchPrimitiveThumb {...props} asChild >
      <S.SwitchContent>
        {children}
      </S.SwitchContent>
    </S.SwitchPrimitiveThumb>
  )
}